import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import userModule from "./modules/user";
import globalSnackbarModule from "./modules/globalSnackbar";
import retailLocationModule from "./modules/retailLocation";
import state from "./state";
import getters from "./getters";
import mutations from "./mutations";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  modules: [
    // only save these modules to local storage
    "user",
    "retailLocation"
  ]
});

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  modules: {
    user: userModule,
    globalSnackbar: globalSnackbarModule,
    retailLocation: retailLocationModule
  },
  plugins: [
    vuexLocal.plugin
  ]
});

export default store;
